import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_empleado`);
  return response;
};

const getFilter = async (tipo_periodo, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_empleado/${tipo_periodo}/${anio}/${num_periodo}`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_empleado/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_empleado/${id}`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}movimiento_empleado`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}movimiento_empleado`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}movimiento_empleado/${id}`);
  return response;
};

const deleteImported = async (periodo_id, anio, num_periodo) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}movimiento_empleado/importados/${periodo_id}/${anio}/${num_periodo}`);
  return response;
};

const importBulk = async (file, periodo_id, anio, num_periodo, force_save = false) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('periodo_id', periodo_id);
  formData.append('anio', anio);
  formData.append('num_periodo', num_periodo);
  formData.append('force_save', force_save ? 1 : 0);  // Enviar como 0 o 1
  
  // Configurar headers para multipart/form-data
  const token = localStorage.getItem('token');
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'x-access-token': '1',
      'Content-Type': 'multipart/form-data',
    },
  };
  
  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}movimiento_empleado/import`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
      },
      body: formData,
    });
    
    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const importBulkConfirm = async (periodo_id, anio, num_periodo, cached_records) => {
  const token = localStorage.getItem('token');
  
  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}movimiento_empleado/import/confirm`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        periodo_id,
        anio,
        num_periodo,
        cached_records
      }),
    });
    
    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

export { getAll, getFilter, getList, getById, insert, update, drop, deleteImported, importBulk, importBulkConfirm };
